import { combineReducers } from 'redux';

import mutationStatus, * as fromMutationStatus from './mutationStatus';

import type { RadarState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/radar';

export default combineReducers({
  mutationStatus,
});

export const isLoadingRadarMutation = (state: RadarState): boolean =>
  fromMutationStatus.isLoading(state.mutationStatus);
